import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-cream-beige" data-id="element-226" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-227" data-mp="cn7tv1a4qo2i">
        <div className="text-center mb-16" data-id="element-228" data-mp="7pemw6105q16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-navy" data-id="element-229" data-mp="7qhdecuexqgk">
            📚 THE 7-VOLUME TAEKWONDO SYSTEM
          </h2>
          <p className="text-xl text-navy-medium" data-id="element-230" data-mp="3g2vchi7llgt1">
            <span className="text-gold font-semibold" data-id="element-231" data-mp="3c4ntegpnw3eo">150 ready-to-teach sessions</span> · Beginner
            to advanced · Nothing to build from scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-232" data-mp="3l3ssbo54xyrd">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-cream-card rounded-2xl border ${volume.popular ? 'border-gold shadow-lg' : 'border-gold-light shadow-sm'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-233" data-mp="2xe85uv9rwjdc" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-gold text-white font-bold text-xs py-1 px-10 rotate-45 shadow" data-id="element-234" data-mp="2o6hl1y6c2ilp">
                  ⭐ MOST POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-235" data-mp="1vhtubn2tf10r">
                <span className="text-4xl" aria-hidden="true" data-id="element-236" data-mp="20e0z3cjh66h4">
                  {volume.icon}
                </span>
                <div data-id="element-237" data-mp="24hqlpwgladzi">
                  <div className="text-gold font-bold text-sm uppercase tracking-wider" data-id="element-238" data-mp="24e2s6xb59rks">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-navy" data-id="element-239" data-mp="3fujcb3xn8wdz">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-navy-medium font-medium mb-6 italic border-l-2 border-gold pl-4" data-id="element-240" data-mp="1bsj4wtqoffhj">
                {volume.subtitle}
              </p>

              <div className="mb-6" data-id="element-241" data-mp="1pp4xpqboqe53">
                <h4 className="text-sm font-bold text-ink-soft uppercase tracking-wider mb-2" data-id="element-242" data-mp="1ks64rb3rcd8h">
                  What does this solve for your teaching?
                </h4>
                <p className="text-ink text-sm leading-relaxed" data-id="element-243" data-mp="t18fkh0lnarr">{volume.problem}</p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-244" data-mp="16sd5gre60oow">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-245" data-mp="121en7m9m9gj0">
                    <CheckCircle2 size={18} className="text-emerald-brand shrink-0 mt-0.5" data-id="element-246" data-mp="1203k7onzwcsy" />
                    <span className="text-ink text-sm" data-id="element-247" data-mp="ea96z5zrkm86">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-cream-beige border border-gold-light rounded-xl p-4 mt-auto" data-id="element-248" data-mp="2l0uodrw3u0se">
                <span className="text-navy font-bold block mb-1" data-id="element-249" data-mp="2pr2qhojgap5o">Result:</span>
                <p className="text-ink text-sm" data-id="element-250" data-mp="2pt5qn1ebhyo4">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}